module.exports = __webpack_public_path__ + "f7be424015f990b8a30da4d92e3d042e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-30@2x.png
// module id = 511
// module chunks = 0